/**
 * 사이트 이름·제목.
 *
 * 브라우저 탭과 검색 결과에 나오는 제목이다. public/index.html의 <title>·og:title과
 * 같은 값이어야 한다 — 페이지를 떠날 때 탭 제목을 되돌리는 코드가 이 값을 쓴다.
 */
export const SITE_NAME = '캐스타 CASTAR';

export const SITE_TITLE = '캐스타 CASTAR | 배우 모집·오디션·배우 프로필 플랫폼';

/** 개별 페이지 제목 — "김민지 | 캐스타 CASTAR" */
export const pageTitle = (name) => (name ? `${name} | ${SITE_NAME}` : SITE_TITLE);
